import { useCallback, useContext } from 'react';
import { message } from 'antd';
import { useService } from '@core/inversify-react';
import { tableFilterQueryMaker } from '@core/table';

import { GetDeclarationsExcelRepoType, GetDeclarationsExcelMiniRepoType, IGetDeclarationsExcelRepo, IGetDeclarationsExcelMiniRepo } from '../repos';
import { PartnerDeclarationTableContext } from '../context';

export const usePartnerDeclarationsActionBar = () => {
  const { selection, state, resetSelection, selectAll, fetch, reset } = useContext(PartnerDeclarationTableContext);

  const getDeclarationsExcelRepo = useService<IGetDeclarationsExcelRepo>(GetDeclarationsExcelRepoType);
  const getDeclarationsExcelMiniRepo = useService<IGetDeclarationsExcelMiniRepo>(GetDeclarationsExcelMiniRepoType);

  const exportMiniAsExcel = useCallback(async () => {
    message.loading({ key: 1, content: 'Sənəd hazırlanır...', duration: null });

    const result = await getDeclarationsExcelMiniRepo.execute({ query: tableFilterQueryMaker(state.filters), only_partner: 1 });

    if (result.status === 200) {
      message.success({ key: 1, content: 'Sənəd yüklənir' });
      const blob = result.response;
      const objectURL = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = objectURL;
      a.download = `partner_declarations_export_mini_${Math.round(Math.random() * 1000)}.xls`;
      a.click();
    } else {
      message.error({ key: 1, content: result.response });
    }
  }, [getDeclarationsExcelMiniRepo, state.filters]);

  const exportAsExcel = useCallback(async () => {
    message.loading({ key: 1, content: 'Sənəd hazırlanır...', duration: null });

    const result = await getDeclarationsExcelRepo.execute({ query: tableFilterQueryMaker(state.filters), only_partner: 1 });

    if (result.status === 200) {
      message.success({ key: 1, content: 'Sənəd yüklənir' });
      const blob = result.response;
      const objectURL = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = objectURL;
      a.download = `partner_declarations_export_${Math.round(Math.random() * 1000)}.xls`;
      a.click();
    } else {
      message.error({ key: 1, content: result.response });
    }
  }, [getDeclarationsExcelRepo, state.filters]);

  return {
    state,
    selection,
    resetSelection,
    selectAll,
    fetch,
    reset,
    exportAsExcel,
    exportMiniAsExcel,
  };
};
